<template>
  <div class="width98 margin-auto" style="background: #f6f7fb">
    <div class="width100 border-rd3 backwihte">
      <div class="flex-betweenwrap indicatrixitem">
        <p>
          <span>经济效应与研发投入</span>
        </p>
        <img src="@/assets/barsvg/sy-tz.svg" alt="" />
      </div>
      <div id="rdstat" class="echarts-box"></div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { indexrdstat } from "@/api/newhead/newhead.api";
import * as echarts from "echarts";

export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
    };
  },

  components: {},
  methods: {
    toexpenses() {
      this.$router.push({
        path: "/expenses-money/Cost-collection",
      });
    },
  },
  created() {},
  mounted() {
    // 经济效益与研发投入

    // 经济效益与研发投入
    indexrdstat({}).then((res) => {
      if (res.data.code == 200) {
        let monthcont = [];
        let asset_amount = [];
        let debt = [];
        let fee = [];
        let income = [];
        let profit = [];
        let rd_investment = [];
        let wage = [];
        res.data.data.forEach((i) => {
          monthcont.push(i.month);
          asset_amount.push(i.asset_amount);
          debt.push(i.debt);
          fee.push(i.fee);
          income.push(i.income);
          profit.push(i.profit);
          rd_investment.push(i.rd_investment);
          wage.push(i.wage);
        });
        var chartDomrd = document.getElementById("rdstat");
        var myChartrd = echarts.init(chartDomrd);
        var optionrd;

        optionrd = {
          title: {
            // text: "Stacked Line",
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: [
              "资产总额",
              "投入",
              "负债",
              "研发费用",
              "收入",
              "利润",
              "工资",
            ],
            bottom: "-1%",
            type: "scroll", //分页类型
            orient: "horizontal", //横向
            //orient: "vertical", // 图例排列方式默认横着vertical为竖着
            height: 50,
            pageIconColor: "#ff781f", //翻页箭头颜色
            pageTextStyle: {
              color: "#999", //翻页数字颜色
            }, //翻页数字设置
            pageIconSize: 13,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            top: "-14%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "资产总额",
              type: "line",
              color: "#BFB3FF",
              data: asset_amount,
            },
            {
              name: "投入",
              type: "line",
              color: "#7B83EA",
              data: rd_investment,
            },
            {
              name: "负债",
              type: "line",

              data: debt,
            },
            {
              name: "研发费用",
              type: "line",

              data: fee,
            },
            {
              name: "收入",
              type: "line",
              color: "#52C5CB",
              data: income,
            },
            {
              name: "利润",
              type: "line",
              color: "#9CEFE2",
              data: profit,
            },

            {
              name: "工资",
              type: "line",

              data: wage,
            },
          ],
        };

        optionrd && myChartrd.setOption(optionrd);

        window.addEventListener("resize", function () {
          myChartrd.resize();
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.indicatrixitem {
  height: 55px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353a44;
  line-height: 55px;
  font-weight: 600;
  padding: 0 15px 0 15px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}

.echarts-box {
  width: 100%;
  height: 365px;
  /* background: #f2f2f2; */
  position: relative;
  top: -10px;
}
</style>